import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './index.css'

const Index = () => {
  return (
    <div className='shopifymessage_wrapper'>
        <div className='shopifymessage_container'>
            <div className='shopifymessage_icon_failed'>
                <FontAwesomeIcon icon={faXmark}/>
            </div>
            <p>Something went wrong</p>
        </div>
    </div>
  )
}

export default Index
